import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import esMX from "./es-MX.json";

// Un solo idioma en v1. La estructura queda lista para añadir en-US
// traduciendo el JSON, sin tocar ningún componente (spec §7.4).
void i18n.use(initReactI18next).init({
  resources: { "es-MX": { translation: esMX } },
  lng: "es-MX",
  fallbackLng: "es-MX",
  interpolation: { escapeValue: false },
});

export default i18n;
